import React from 'react';
import { useTranslation } from 'react-i18next';
import { Card } from '@totalsoft/rocket-ui';
import ListAltIcon from '@mui/icons-material/ListAlt';
import { CollectionType, getListBrowserStore } from '@ts-private/list-browser';
import { ExportModalComponent } from 'components/common/export/ExportModalComponent';
import io from '../io';
import { useMemo } from 'react';
import ApolloFetchingComponent from 'features/common/components/apollo-fetching/ApolloFetchingComponent';
import TableListBrowser from 'features/common/components/table-list-browser/TableListBrowser';
import AssetHierarchyTypeContainer from './AssetHierarchyTypeContainer';

export const assetHierarchyTypesStore = getListBrowserStore({
  withQueryFilters: false,
  filterDefinitions: [
    {
      name: 'hierarchyProvider',
      caption: 'AssetHierarchy.List.Filter.HierarchyProvider',
      type: 'select',
      underlyingType: 'text'
    },
    {
      name: 'assetType',
      caption: 'AssetHierarchy.List.Filter.AssetType',
      type: 'select',
      underlyingType: 'number'
    }
  ],
  orderByFields: [
    {
      caption: 'AssetHierarchy.List.Filter.HierarchyProvider',
      value: 'hierarchyProvider'
    }
  ],
  pager: {
    orderBy: 'hierarchyProvider',
    direction: 'asc'
  }
});

const AssetHierarchyTypeBrowser = () => {
  const { t } = useTranslation();

  const fetchingOptions = useMemo(
    () => ({
      queryOptions: {
        query: io.queries.TYPE_ASSET_HIERARCHY_LIST_QUERY,
        name: 'assetHierarchiesType'
      },
      collectionsOptions: [
        {
          queryOptions: { query: io.queries.ASSET_HIERARCHY_SOURCES_QUERY },
          name: 'assetHierarchySources',
          identifier: 'hierarchyProvider',
          collectionType: CollectionType.Filter,
          valueKey: 'name',
          labelKey: 'name'
        },
        {
          queryOptions: { query: io.queries.ASSET_TYPES_QUERY },
          name: 'assetHierarchyTypes',
          identifier: 'assetType',
          collectionType: CollectionType.Filter,
          valueKey: 'id',
          labelKey: 'name'
        }
      ]
    }),
    []
  );

  const columns = useMemo(
    () => [
      { name: 'assetType', caption: 'AssetHierarchy.List.Row.AssetType' },
      { name: 'hierarchyRootPickLink', caption: 'AssetHierarchy.List.Row.HierarchyRootPicLink' },
      { name: 'actions', caption: 'Actions', width: '125px' }
    ],
    []
  );

  return (
    <Card icon={ListAltIcon} title={t('AssetHierarchy.List.TypeTitle')}>
      <TableListBrowser
        name='asset-hierarchy-types-browser'
        store={assetHierarchyTypesStore}
        ItemComponent={AssetHierarchyTypeContainer}
        columns={columns}
      />
      <ExportModalComponent store={assetHierarchyTypesStore} options={fetchingOptions} />
      <ApolloFetchingComponent store={assetHierarchyTypesStore} options={fetchingOptions} />
    </Card>
  );
};

export default AssetHierarchyTypeBrowser;
